import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './plugins/router';
import store from './store/index'
import ApiService from "./services/api.service";
import "./plugins/filter";

Vue.config.productionTip = false

ApiService.init()

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
